var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGbFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gb 1",
    clipPath: "url(#clip0_4485_1659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0H18V14H0V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.10938 0L8.97188 5.27917L15.8062 0H18V1.80833L11.25 7.02917L18 12.2208V14H15.75L9 8.77917L2.27813 14H0V12.25L6.72187 7.05833L0 1.86667V0H2.10938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.925 8.19583L18 12.8333V14L10.3781 8.19583H11.925ZM6.75 8.77917L6.91875 9.8L1.51875 14H0L6.75 8.77917ZM18 0V0.0875L10.9969 5.57083L11.0531 4.2875L16.5938 0H18ZM0 0L6.72187 5.13333H5.03437L0 1.225V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.77812 0V14H11.2781V0H6.77812ZM0 4.66667V9.33333H18V4.66667H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M0 5.62917V8.42917H18V5.62917H0ZM7.67812 0V14H10.3781V0H7.67812Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4485_1659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbFlag);
export default __webpack_public_path__ + "static/media/gb-flag.d9e9f3027a457ef0b5ced0c0a35fd954.svg";
export { ForwardRef as ReactComponent };